export enum UnitTypes {
  TYPE_CLOSE = 'Close',
  TYPE_FORMAT_TRANSFORMATION = 'Format transformation',
  IKEA_HSP = 'Home Service Point',
  IKEA_MPAOP = 'IKEA Mini Plan And Order Point',
  IKEA_PICK_UP_AND_ORDER_POINT = 'IKEA Pick Up And Order Point',
  IKEA_PICK_UP_POINT_BRANDED = 'IKEA Pick Up Point Branded',
  IKEA_PICK_UP_POINT_UNBRANDED = 'IKEA Pick Up Point Unbranded',
  IKEA_PLAN_AND_ORDER_POINT = 'IKEA Plan And Order Point',
  IKEA_PLAN_AND_ORDER_POINT_S = 'IKEA Plan And Order Point (S)',
  IKEA_PLAN_AND_ORDER_POINT_XS = 'IKEA Plan And Order Point (XS)',
  IKEA_POP_UP = 'IKEA Pop Up',
  IKEA_SMALL_STORE_L = 'IKEA Small Store (L)',
  IKEA_SMALL_STORE_LADA_M = 'IKEA Small Store (M) Lada',
  IKEA_SMALL_STORE_LADA_S = 'IKEA Small Store (S) Lada',
  IKEA_SMALL_STORE_M = 'IKEA Small Store (M)',
  IKEA_SMALL_STORE_S = 'IKEA Small Store (S)',
  IKEA_STORE = 'IKEA Store',
  LDC = 'LDC',
  MEETING_PLACE = 'CentresMeetingPlace',
  CDC = 'CDC',
  CPU = 'CPU',
  CSC = 'CSC',
  DC = 'DC',
  DCWH = 'DCWH',
  DH = 'digitalHub',
  EC = 'explorationCase',
  EMPU = 'EMPU',
  NCBA = 'noneCoreAsset',
  RWH_CDC = 'RWHCDC',
  RWH_CMP = 'RWHCMP',
  SO = 'serviceOffice',
  TYPE_NEW = 'New',
  TYPE_RELOCATION = 'Relocation',
  CFU_LANDBANK = 'Landbank',
}

export enum TransactionTypes {
  BUY = 'Buy',
  DIVEST = 'Divest',
  FULLY_CONTRACTED_UNIT = 'Fully Contracted Unit',
  LEASE = 'Lease',
  LEASE_EXPIRATION = 'Lease Expiration',
  LEASE_TERMINATION = 'Lease Termination',
  NO_TRANSACTION = 'No Transaction',
  STRATEGIC_LAND_ACQUISITION = 'Strategic Land Acquisition',
}

export enum AutomationLevelTypes {
  FULL = 'Full',
  PARTIAL = 'Partial',
}

export enum SiteTypeEnum {
  BUILDING = 'Building',
  LAND = 'Land',
  PART_OF_BUILDING = 'Part of Building',
  PART_OF_LAND = 'Part of Land',
}

export enum SiteProgressEnum {
  EXISTING = 'Existing site',
  FEASIBILITY_STUDY_ONGOING = 'Feasibility study ongoing',
  FULL_DUE_DILIGENCE_ONGOING = 'Full due diligence ongoing',
  LIGHT_DUE_DILIGENCE = 'Light due diligence ongoing',
  SEARCH_NOT_STARTED = 'Site search not started',
  SEARCH_ONGOING = 'Site search ongoing',
  SITE_ACQUISITION_ONGOING = 'Site acqusition ongoing',
  SITE_CONFIRMATION_SIGNED = 'Site confirmation & agreement signed',
  SITE_SELECTION = 'Site selection (DP1)',
}

export enum ReClusterResponsibleEnum {
  RESPONSIBLE = 'responsible',
}

export enum EstablishmentTypesEnum {
  CLOSE = 'Close',
  FORMAT_TRANSFORMATION = 'Format-Transformation',
  NEW = 'New',
  RELOCATION = 'Relocation',
}

export enum SolutionPuposesEnum {
  BUSINESS_CONTINUITY = 'businessContinuity',
  COMPLIANCE = 'compliance',
  COST_SAVINGS = 'costsavings',
  GROWTH = 'growth',
  LIFE_CYCLE = 'lifeCycle',
  SUSTAINABILITY = 'sustainability',
}

export enum CommentTypesEnum {
  COUNTRY_PROJECT_STATUS_COMMENTS = 'COUNTRY_PROJECT_STATUS_COMMENTS',
  PROJECT_TIME_STATUS_COMMENTS = 'PROJECT_TIME_STATUS_COMMENTS',
}

export enum SolutionTypesEnum {
  ADAPTIVE_SCHEDULING_AND_OPTIMIZATON = 'adaptiveScheduling',
  ADAPTIVE_SCHEDULING_AND_OPTIMIZATION = 'adaptiveSchedulingAndOptimization',
  AUTOMATION_HIGH = 'automationHigh',
  AUTOMATION_MEDIUM = 'automationMedium',
  BMS_UPGRADE = 'bmsUpgrade',
  CASH_LINE = 'cashLine',
  CHECKOUT_POS = 'CHECKOUT_POS',
  COMMERCIAL_EXTENSION = 'commercialExtension',
  COMMERCIAL_REPAIRS = 'commercialRepairs',
  COMMERCIAL_USE = 'Commercial use',
  CONCRETE_FLOORING = 'concreteFlooring',
  CONVENTIONAL_WAREHOUSE_RACKING = 'conventionalWarehouseRacking',
  CO_WORKER_RESTAURANT_AREA = 'coWorkerRestaurantArea',
  CO_WORKER_SPACES = 'coWorkerSpaces',
  CSC = 'CSC',
  CUSTOMER_SERVICES_CLICK_AND_COLLECT = 'customerServicesClickAndCollect',
  CUSTOMER_SERVICES_OTHER = 'customerServicesOther',
  DC_FIT_FOR_FUTURE = 'dcFitForFuture',
  ECOPILOT = 'ecopilot',
  ENERGY_EFFICIENCY = 'energyEfficiency',
  ENERGY_ENVELOPE_DOORS = 'energyEnvelopeDoors',
  ENERGY_ENVELOPE_FACADE = 'energyEnvelopeFacade',
  ENERGY_ENVELOPE_ROOF = 'energyEnvelopeRoof',
  ENTRANCE = 'entrance',
  EQUIPMENT_REPLACEMENT_OR_UPGRADE = 'equipmentReplacementOrUpgrade',
  EV_CHARGERS = 'evChargers',
  EXIT = 'exit',
  EXTENSION = 'extension',
  FACADE_REPAIRS = 'facadeRepairs',
  FLOORING_REPAIRS = 'flooringRepairs',
  FUEL_CEIL = 'fuelCell',
  FULL_COMMERCIAL_REBUILD = 'fullCommercialRebuild',
  GENERATORS = 'generators',
  GO_DARK = 'goDark',
  HOSTING = 'HOSTING',
  HVAC = 'hvac',
  IN_STORE_NAVIGATION = 'inStoreNavigation',
  KITCHEN_AND_DINING = 'kitchenAndDining',
  LAN = 'LAN',
  LED = 'led',
  LEGAL_OR_CONTRACTUAL = 'legalOrContractual',
  LIGHTING_NON_LED = 'lightingNonLED',
  LIGHTNING_NON_LED = 'lightningNonLed',
  MARKET_HALL = 'marketHall',
  METERING = 'metering',
  OPTIMISATION_OF_BUILDING_PREMISE_WITH_3RD_PARTY = 'optimisationOfBuildingPremiseWith3rdParty',
  OPTIMISATION_OF_PARKING_LAND_WITH_3RD_PARTY = 'optimisationOfParkingLandWith3rdParty',
  OTHER = 'Other',
  OTHER_COMMERCIAL_SOLUTION = 'otherCommercialSolution',
  OTHER_CONCEPTUAL_SOLUTION = 'otherConceptualSolution',
  OTHER_FOOD_SOLUTION = 'Other Food solution',
  OTHER_FULFILMENT_AND_REPLENISHMENT = 'otherFulfilmentAndReplenishment',
  PARKING_AREAS = 'parkingAreas',
  PARKING_REPAIRS = 'parkingRepairs',
  PHOTOVOLTAIC_PANELS = 'photovoltaicPanels',
  POWER_OPTIMISER_E_POWER = 'poweroptimiserEPower',
  PUBLIC_INFRASTRUCTURE_INTERVENTION = 'publicInfrastructureIntervention',
  PV = 'photovoltaicPanels',
  RACKING_AND_OTHER_WAREHOUSE_SOLUTIONS = 'Racking and other warehouse solutions',
  REDESIGN_STEP_1_OTHER = 'redesignStep1Other',
  REDESIGN_STEP_1_VASS = 'redesignStep1Vass',
  REDESIGN_STEP_2 = 'redesignStep2',
  REDESIGN_STEP_3_CLICK_AND_COLLECT_LOCKERS = 'redesignStep3ClickAndCollectLockers',
  REDESIGN_STEP_3_COSS = 'redesignStep3Coss',
  REDESIGN_STEP_3_LAYOUT = 'redesignStep3Layout',
  REDESIGN_STEP_4 = 'redesignStep4',
  REDESIGN_STEP_5 = 'redesignStep5',
  REDESIGN_STEP_6 = 'redesignStep6',
  REPLENISHMENT_CAPABILITIES = 'replenishmentCapabilities',
  RESTROOMS = 'restrooms',
  RHC = 'rhc',
  ROOF_REPAIRS = 'roofRepairs',
  SAFETY_AND_SECURITY = 'safetyAndSecurity',
  SHOW_ROOM = 'showRoom',
  SPACE_OPT = 'spaceOptwOtherIKEABusinesses',
  STRUCTURAL_UPGRADES_AND_REPAIRS = 'structuralUpgradesAndRepairs',
  SWEDISH_BISTRO = 'swedishBistro',
  SWEDISH_BITE = 'swedishBite',
  SWEDISH_CAFE = 'swedishCafe',
  SWEDISH_DELI = 'swedishDeli',
  SWEDISH_FOOD_MARKET = 'swedishFoodMarket',
  SWEDISH_RESTAURANT = 'swedishRestaurant',
  SWEDISH_SNACKS = 'swedishSnacks',
  TECHNICAL_SYSTEMS_AND_EQUIPMENT_REPLACEMENTS_UPGRADES_AND_REPAIRS = 'equipmentReplacementOrUpgrade',
  TRADE_DRESS = 'tradeDress',
  TRADE_DRESS_REPLACEMENT = 'tradeDressReplacement',
  WAN = 'WAN',
  WASTE_BALER = 'wasteBaler',
  WASTE_BALERS = 'wasteBalers',
  WASTE_OTHER = 'wasteOther',
  WASTE_WATER_MANAGEMENT = 'wasteWaterManagement',
  WATER_RELATED_SYSTEMS = 'waterRelatedSystems',
  WIFI = 'WIFI',
  ZERO_EMISSION_CO_WORKER_AND_CUSTOMER_CHARGING = 'zeroEmissionCoWorkerAndCustomerCharging',
  ZERO_EMISSION_HDT_CHARGERS = 'zeroEmissionHdtChargers',
  ZERO_EMISSION_LAST_MILE_DELIVERY_CHARGING = 'zeroEmissionLastMileDeliveryCharging',
  ZERO_EMISSION_LAST_MILE_DELIVERY_FLEET = 'zeroEmissionLastMileDeliveryFleet',
}

export enum SolutionCategoriesEnum {
  COMMERCIAL_AND_COWORKER_AREAS = 'COMMERCIAL_AND_COWORKER_AREAS',
  CONCEPT = 'CONCEPT',
  FULFILMENT_AND_REPLENISHMENT = 'FULFILMENT_AND_REPLENISHMENT',
  FOOD = 'FOOD',
  REAL_ESTATE = 'REAL_ESTATE',
  SPACE_OPTIMIZATION_WITH_3RD_PARTIES = 'SPACE_OPTIMIZATION_WITH_3RD_PARTIES',
  DIGITAL_TECHNOLOGY = 'DIGITAL_TECHNOLOGY',
  ASSET_LIFECYCLE_AND_COMPLIANCE = 'ASSET_LIFECYCLE_AND_COMPLIANCE',
  ENERGY_WATER_WASTE_MANAGEMENT = 'ENERGY_WATER_WASTE_MANAGEMENT',
}
